module.exports = __webpack_public_path__ + "static/media/carsis-wheel.620389d0.jpg";